import dayjs from "dayjs";
import { END_POINTS } from "../api/EndPoints";
import fetcher from "../api/fetcher";
import { PATH_DASHBOARD } from "../routes/paths";
import { showToast } from "./Toast";

export function hideEmail(email: string) {
  const [local, domain] = email.split("@");
  const hiddenLocal =
    local[0] + "*".repeat(local.length - 2) + local[local.length - 1];
  return hiddenLocal + "@" + domain;
}

export function hideMobileNumber(number: string) {
  return number.slice(0, 2) + "*".repeat(number.length - 4) + number.slice(-2);
}

export function customSnakeCase(str: string) {
  return str.toLowerCase().replaceAll(" ", "_");
}

export function getLocation() {
  if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        console.log("Latitude:", position.coords.latitude);
        console.log("Longitude:", position.coords.longitude);
      },
      (error) => {
        console.error("Error getting location:", error.message);
      },
    );
  } else {
    console.error("Geolocation is not supported by this browser.");
  }
}

export const TabsData = [
  {
    label: "Business Verification",
    url: "/kyc/businessVerification",
    value: 0,
  },
  { label: "Business Documents", url: "/kyc/businessDocuments", value: 2 },
  {
    label: "Director / Promoter(s)",
    url: "/kyc/directorAndPromoter",
    value: 3,
  },
  { label: "Director Document", url: "/kyc/DirectorDocuments", value: 5 },
  { label: "Application review", url: "/kyc/applicationReview", value: 6 },
];

export const RouteAnimation = {
  initial: { opacity: 0, x: -600 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -600 },
  transition: {
    type: "spring",
    stiffness: 100,
    damping: 12,
  },
  transitionTime: 300,
};

export const getSignedUrl = async (url: string) => {
  try {
    const response = await fetcher.get(END_POINTS.AUTH.SIGN_S3_URL(url));
    return response?.data?.preSignedUrl;
  } catch (error) {}
};

export const modalsSyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1.5,
  p: 4,
};

export const getDaysBetweenDates = (startDate: string, endDate: string) => {
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  return end.diff(start, "day") + 1;
};

export const getCurrentLocation = (): Promise<{
  latitude: string;
  longitude: string;
}> => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      showToast.error("Geolocation is not supported by this browser.");
      return reject(new Error("Geolocation is not supported by this browser."));
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = position.coords.latitude.toString();
        const longitude = position.coords.longitude.toString();
        resolve({ latitude, longitude });
      },
      (error) => {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            showToast.error("Permission denied. Please allow location access.");
            reject(
              new Error("Permission denied. Please allow location access."),
            );
            break;
          case error.POSITION_UNAVAILABLE:
            showToast.error("Location unavailable. Try again later.");
            reject(new Error("Location unavailable. Try again later."));
            break;
          case error.TIMEOUT:
            showToast.error("Location request timed out.");
            reject(new Error("Location request timed out."));
            break;
          default:
            showToast.error(
              "An unknown error occurred while fetching location.",
            );
            reject(
              new Error("An unknown error occurred while fetching location."),
            );
        }
      },
    );
  });
};
